import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import 'slick-carousel';
import App from 'resizement/scripts/resize';

Snappy.Component.Carousel = class Carousel extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-carousel';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.isOn = true;
        this.$carousel = this.$element.find('.carousel');

        this.options = {
            arrows: this.$element.data('carouselArrows'),
            autoplay: this.$element.data('carouselAutoplay'),
            autoplaySpeed: this.$element.data('carouselAutoplaySpeed'),
            pauseOnHover: this.$element.data('carouselPauseOnHover'),
            dots: this.$element.data('carouselDots'),
            slidesToShow: this.$element.data('carouselSlidesToShow') || 1,
            slidesToScroll: this.$element.data('carouselSlidesToScroll') || 1,
            speed: this.$element.data('carouselSpeed'),
            fade: this.$element.data('carouselFade'),
            appendDots: this.$element.find(this.$element.data('carouselDotsContainer')),
            mobileFirst: this.$element.data('carouselMobileFirst'),
            adaptiveHeight: this.$element.data('carouselAdaptiveHeight'),
            accessibility: this.$element.data('carouselAccessibility') || false,
            touchThreshold: 10,
            variableWidth: this.$element.data('carouselVariableWidth'),
            centerMode: this.$element.data('carouselCenterMode'),
            infinite: this.$element.data('carouselInfinite'),
            draggable: this.$element.data('carouselDraggable'),

            //here are not slick options
            arrowsTheme: this.$element.data('carouselArrowsTheme'),
            dynamicArrowsColor: this.$element.data('carouselDynamicArrowsColor'),
            mobileOn:
                this.$element.data('mobileOn') !== undefined
                    ? this.$element.data('mobileOn')
                    : true,
            tabletOn:
                this.$element.data('tabletOn') !== undefined
                    ? this.$element.data('tabletOn')
                    : true,
            desktopOn:
                this.$element.data('desktopOn') !== undefined
                    ? this.$element.data('desktopOn')
                    : true
        };

        if (this.$element.data('carouselResponsive')) {
            if (this.$element.data('carouselResponsiveUnslick') !== undefined) {
                this.options.responsive = [
                    {
                        breakpoint: parseInt(
                            this.$element.data('carouselResponsiveBreakpoint'),
                            10
                        ),
                        settings: 'unslick'
                    }
                ];
            } else {
                this.options.responsive = this.getResponsiveBreakpointConfig(
                    this.$element.data('carouselResponsiveBreakpoint'),
                    this.$element.data('carouselResponsiveSlidesToShow'),
                    this.$element.data('carouselResponsiveSlidesToScroll')
                );
            }
        }
    }

    setEventListeners() {
        $(window).on('resize:finished', this.onResize.bind(this));

        if (this.options.dynamicArrowsColor) {
            this.$carousel.on('afterChange', this.setArrowsColor.bind(this));
        }

        this.$carousel.on('swipe', this.swipeHandler.bind(this));
        
    }

    getResponsiveBreakpointConfig(breakpoints, slidesToShow, slidesToScroll) {
        const responsiveBreakpoints = [];

        breakpoints = breakpoints.toString().split(',');

        slidesToShow = slidesToShow ? (slidesToShow = slidesToShow.toString().split(',')) : [];
        slidesToScroll = slidesToScroll ? slidesToScroll.toString().split(',') : [];

        $.each(breakpoints, (i, breakpoint) => {
            responsiveBreakpoints.push({
                breakpoint: parseInt(breakpoint, 10),
                settings: {
                    slidesToShow: parseFloat(slidesToShow[i], 10) || 1,
                    slidesToScroll: parseFloat(slidesToScroll[i], 10) || 1
                }
            });
        });

        return responsiveBreakpoints;
    }

    initCarousel() {
        this.setArrowsTheme();

        if (this.$element.data('carouselDeferInit')) {
            return false;
        }

        if (this.$carousel.hasClass('slick-initialized') && !this.isOn) {
            this.$carousel.slick('unslick');
        }

        if (!this.$carousel.hasClass('slick-initialized') && this.isOn) {
            this.$carousel.slick(this.options);
        }

        this.setArrowsColor();
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.onResize();
    }

    setArrowsTheme() {
        if (!this.options.arrowsTheme) {
            return;
        }
        switch (this.options.arrowsTheme) {
        case 'cfa':
            this.options.prevArrow = `<button
                class="slick-prev"
                type="button"
                title="Previous Slide"
                aria-label="Previous Slide"
                data-gtm-on = "click"
                data-gtm-category="${Carousel.currentSection}"
                data-gtm-action="Carousel Arrow"
                data-gtm-label = "Previous Slide">
                        <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">
                            <use xlink:href="#icon-chevron-left"></use>
                        </svg>
                    </button>`;
            this.options.nextArrow = `<button
                class="slick-next"
                type="button"
                title="Next Slide"
                aria-label="Next Slide"
                data-gtm-on = "click"
                data-gtm-category="${Carousel.currentSection}"
                data-gtm-action="Carousel Arrow"
                data-gtm-label = "Next Slide">
                        <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">
                            <use xlink:href="#icon-chevron-right"></use>
                        </svg>
                    </button>`;
            break;

        case 'edu':
            this.options.prevArrow = `<button
                class="slick-prev js-arrow-left"
                title="Previous Slide test"
                aria-label="Previous Slide "
                data-gtm-on = "click"
                data-gtm-event-category="${Carousel.currentSection}"
                data-gtm-event-action="Carousel Arrow"
                data-gtm-event-label = "Previous Slide"
                tabindex="-1">
                        <svg class="icon icon-arrow" width="16" height="28" aria-hidden="true" focusable="false">
                            <use xlink:href="#icon-chevron-left-thin"></use>
                        </svg>
                    </button>`;
            this.options.nextArrow = `<button
                class="slick-next js-arrow-right"
                title="Next Slide test"
                aria-label="Next Slide"
                data-gtm-on = "click"
                data-gtm-event-category="${Carousel.currentSection}"
                data-gtm-event-action="Carousel Arrow"
                data-gtm-event-label = "Next Slide"
                tabindex="-1">
                        <svg class="icon icon-arrow" width="16" height="28" aria-hidden="true" focusable="false">
                            <use xlink:href="#icon-chevron-right-thin"></use>
                        </svg>
                    </button>`;
            break;
        }
    }

    setArrowsColor() {
        if (!this.options.dynamicArrowsColor) {
            return;
        }

        let $activeSlide = this.$carousel.find('.slick-active');
        let activeArrowColor = $activeSlide.data('arrowColor');
        this.$element.removeClass('white-arrows blue-arrows');

        switch (activeArrowColor) {
        case 'white':
        case 'opposite-blue':
                this.$element.addClass( 'white-arrows' );
            break;
        case 'blue':
        case 'opposite-white':
                this.$element.addClass( 'blue-arrows' );
            break;
        }
    }

    onResize() {
        let isMobileOn = !App.isTablet && this.options.mobileOn,
            isTabletOn = App.isTablet && !App.isDesktop && this.options.tabletOn,
            isDesktopOn = App.isDesktop && this.options.desktopOn;
        this.isOn = isMobileOn || isTabletOn || isDesktopOn;

        this.initCarousel();
    }

    swipeHandler(e, slick, direction) {
        $(window).trigger('gtm:send', [ Carousel.currentSection, 'Carousel', 'Swipe ' + direction]);
    }


    static get currentSection() {
        const mainNode = document.querySelector('#main-content');
        if (mainNode) {
            return mainNode.hasAttribute('data-current-section') ? mainNode.getAttribute('data-current-section') : '';
        }
        return '';
    }
};

$(function () {
    $(window).resize(function () {
        $('div.strip-carousel .carousel').slick('resize');
    });
    
    

    // remove aria-live from slick-list
    setTimeout(function () {
        const slickList = [...document.querySelectorAll('.slick-list')];
        slickList.forEach((x) => {
            x.removeAttribute('aria-live');
        });
    }, 500);

});



// WEBPACK FOOTER //
// ./components/carousel/scripts/carousel.js